// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import AppointmentCard from './view'

export default function AppointmentCardFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/AppointmentCard">
      <AppointmentCard {...props}>
        {children}
      </AppointmentCard>
    </Flow>
  )
}
